// types
import { IAHU_Optimizer } from './types'
// components
import { OverviewPanelWrapper } from '../../../components/OverviewPanelWrapper'
// api
import { GrOptimize }  from "react-icons/gr";
import { ValueDisplay } from '../../../components/ValueDisplay'
import { themedUseStyletron } from '../../../../theme/customTheme';

export function OverviewPanel(props: IAHU_Optimizer) {
    const [css, theme] = themedUseStyletron();
    return (
        <OverviewPanelWrapper {...props} icon={<GrOptimize size={'100%'}></GrOptimize>}>

            <ValueDisplay value={props.output} dimension='Pa' ></ValueDisplay>
              
        </OverviewPanelWrapper>
    );
}